export function formatDecimalSeparator(
  value: string,
  separator: ',' | '.' = '.',
  showThousandSeparator = false
): string {
  if (!value) return value;

  const thousandSeparator = separator === '.' ? ',' : '.';
  const [integerPart, decimalPart] = value.split('.');

  const formattedInteger = showThousandSeparator
    ? integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator)
    : integerPart;

  return decimalPart !== undefined ? `${formattedInteger}${separator}${decimalPart}` : formattedInteger;
}